// @flow
import style from "./style.module.scss";

import React, { type Node } from "react";
import { useStaticQuery, graphql } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import { t } from "ttag";

type Props = {
    children: (fallbackImage: {
        imageSrc: string | (() => Node),
        description?: string,
    }) => *,
};

const FallbackImage = ({ children }: Props) => {
    const data = useStaticQuery(graphql`
        query FallbackImageQuery {
            file(relativePath: { eq: "no-image.jpg" }) {
                childImageSharp {
                    gatsbyImageData(
                        width: 310
                        height: 177
                        quality: 100
                        layout: FIXED
                    )
                }
            }
        }
    `);

    const fallbackImage = {
        imageSrc: () => (
            <GatsbyImage
                image={data.file.childImageSharp.gatsbyImageData}
                alt={t`common.text.fallback-image`}
            />
        ),
        description: t`common.text.fallback-image`,
    };

    return children(fallbackImage);
};

export default FallbackImage;

const CarouselFallbackImage = ({ fluid }: *) => (
    <div className={style.carouselFallbackImage}>
        <GatsbyImage image={fluid} alt={t`common.text.fallback-image`} />
    </div>
);

export { CarouselFallbackImage };
